import { CommonModule } from '@angular/common';
import { Component, model, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";

@Component({
    selector: 'lib-date-picker',
    imports: [
		// TODO: Angular 19 WARNINGS: Unused import. Delete if unnecessary
		// MatFormField,
		//______________________
		MatInputModule,
		ReactiveFormsModule,
		CommonModule
	],
    templateUrl: './date-picker.component.html',
    styleUrl: './date-picker.component.scss'
})
export class DatePickerComponent {
	dateLabel = model<string>('Choose a date')
	minDate = model<Date>()
	maxDate = model<Date>()
	dateValue = model<Date>()
	dateSelected = output<Date | undefined>();

	readonly selectedDate = new FormGroup({
		date: new FormControl<Date | null>(null),
	});

	constructor() {
		this.selectedDate.get('date')?.valueChanges.subscribe((value) => {
			this.onDateChange(value);
		});
	}

	onDateChange(date: Date | null): void {
		if (date) {
			this.dateSelected.emit(new Date(date) as Date);
		}
	}

	clearSelectedDate() {
		this.selectedDate.get('date')?.setValue(null);
		this.dateSelected.emit(undefined);
	}
}
